import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as projectActions from "../../actions/projectActions";
import * as layoutActions from "../../actions/layoutActions";
import showToastr from "../../util/toastr.js";

import * as pageConstants from "../../constants/EasterEggConstants";
import * as domainConstants from "../../constants/DomainConstants";

import AutoBindComponent from "../common/AutoBindComponent";
import mergeDeep from "../../util/mergeDeep.js";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";

import convertToLabelValuePair from "../../util/convertToLabelValuePair.js";
import ProjectForm from "../project/ProjectForm";
import ConfirmModal from "../common/ConfirmModal";
import ProjectPageHelper from "../project/ProjectPageHelper";

import * as types from "../../constants/ComponentConstants";
import EasterEggHandler from "../common/EasterEggHandler";

import GenerateGuid from "../../util/guid";
import redirector from "../../util/redirector";

class ProjectPage extends AutoBindComponent {
	constructor(props) {
		super(props);

		this.state = {
			modalIsOpen: false,

			infrastructuurDeleted: false,
			hasUnsavedChanges: false,
			mapKey: GenerateGuid(),
			center: {
				lat: '',
				lng: ''
			},

			nieuwbouwModalIsOpen: false,
			addNieuwbouwInfraModalIsOpen: false,
			deleteNieuwbouwInfraModalIsOpen: false,
			nieuwbouwToRemoveId: null,

			addRenovatieToProjectModalIsOpen: false,
			addRenovatieInfraModalIsOpen: false,

			deleteInfraModalIsOpen: false,
			infraStatusGewijzigd: false,

			project: {
				soortDossier: domainConstants.DOSSIER_SOORT_NIEUWBOUW,
				infrastructuren: []
			},
			draggable: true,
			inEditMode: false,
			saveIsCancelled: false,
			shouldKeepProject: false,
			changedInfrastructuur: ""
		};

		this.pageHelper = new ProjectPageHelper(this, redirector);

		this.prefillHelper = new EasterEggHandler(this, pageConstants.PROJECT);
	}

	// ----------------------------------------------------------------------------
	componentWillReceiveProps(nextProps) {
		if (this.props.project != nextProps.project || (!this.state.newCoordinates && nextProps.project.breedtegraad)) {
			this.setState({
				project: mergeDeep({}, nextProps.project),
				titleSet: nextProps.project.tabTitel
			});

			if ((this.props.project != null && nextProps.project != null && this.props.project.sportinfrastructurenOpKaart != nextProps.project.sportinfrastructurenOpKaart) || (!this.state.newCoordinates && nextProps.project.breedtegraad))
				this.setState({
					newCoordinates: Object.assign({}, { lat: nextProps.project.breedtegraad, lng: nextProps.project.lengtegraad }),
					center: Object.assign({}, { lat: parseFloat(nextProps.project.breedtegraad), lng: parseFloat(nextProps.project.lengtegraad) }),
					mapKey: GenerateGuid()
				});
		}

		if (nextProps.project.naam != this.props.pageHeaderTitle || nextProps.project.tabTitel != this.props.pageHeaderSubtitle) {
			this.props.loadLayout(nextProps.project.naam, nextProps.project.tabTitel, nextProps.dossierId, nextProps.project.initialisatieOK, nextProps.project.typeDossier, nextProps.infrastructuurId, (nextProps.project.redenVanStatus != "121450000" && nextProps.project.redenVanStatus !== 121450000), false);
		}

		this.prefillHelper.initiateGemeenten(this.props.gemeenten);
		this.prefillHelper.initiatePostcoden(this.props.postcodes);
	}

	componentDidMount() {
		const dossierId = this.props.params.dossierId;
		if (!this.props.isLoaded) {
			this.props.loadLayout("", "", dossierId, false, null, this.props.infrastructuurId);
			this.props.loadProject(dossierId);
		}
		else {
			this.setState({
				hasUnsavedChanges: !this.props.isSaved,
				project: mergeDeep({}, this.props.project),
				center: { lat: parseFloat(this.props.project.breedtegraad), lng: parseFloat(this.props.project.lengtegraad) }, mapKey: GenerateGuid()
			});
			this.props.loadLayout(this.props.project.naam, this.props.project.tabTitel, this.props.dossierId, this.props.project.initialisatieOK, this.props.project.typeDossier, this.props.infrastructuurId, (this.props.project.redenVanStatus != "121450000" && this.props.project.redenVanStatus !== 121450000), false);
		}

		this.prefillHelper.bind();
	}

	handleOnChange(event, data, i) {
		this.pageHelper.change(event, data, i);
	}

	// --------------------------NIEUWBOUW--------------------------------------------------

	handleOnEditNieuwbouw(id) {
		this.pageHelper.editNieuwbouw(id);
	}

	handleOnDeleteNieuwbouw(id) {
		this.pageHelper.deleteNieuwbouw(id);
	}

	handleOnCancelDeleteNieuwbouwInfrastructuur() {
		this.pageHelper.cancelDeleteNieuwbouwInfra();
	}

	handleOnGoToDeleteNieuwbouwInfrastructuur() {
		this.pageHelper.gotoDeleteNieuwbouwInfra();
	}

	handleOnAddNieuwbouwInfrastructuur() {
		this.pageHelper.addNieuwbouwInfra();
	}

	handleOnCancelAddNieuwbouwInfrastructuur() {
		this.pageHelper.cancelAddNieuwbouwInfra();
	}

	handleOnGoToAddNieuwbouwInfrastructuur() {
		this.pageHelper.gotoAddNieuwbouwInfra();
	}

	handleOnCloseNieuwbouwModal() {
		this.pageHelper.closeNieuwbouwModal();
	}

	// --------------------------NIEUWBOUW--------------------------------------------------
	// --------------------------RENOVATIE--------------------------------------------------

	handleOnEditRenovatie(id) {
		this.pageHelper.editRenovatie(id);
	}

	handleOnAddRenovatieInfrastructuur() {
		this.pageHelper.addRenovatieInfra();
	}

	handleOnCancelAddRenovatieInfrastructuur() {
		this.pageHelper.cancelAddRenovatieInfra();
	}

	handleOnGoToAddRenovatieInfrastructuur() {
		this.pageHelper.gotoAddRenovatieInfra();
	}

	handleOnChangeRenovatieTable(event, id) {
		this.pageHelper.changeRenovatieTable(event, id);
	}

	handleOnChangeVerdwijnendeInfrasTable(event, id) {
		this.pageHelper.changeVerdwijnendeInfraTable(event, id);
	}

	handleOnCloseAddRenovatieToProjectModal() {
		this.pageHelper.closeAddRenovatieToProjectModal();
	}

	handleOnGoToRenovatieInfrastructuurDetail() {
		this.pageHelper.goToRenovatieInfrastructuurDetail();
	}

	handleOnCancelRenovatieInfrastructuurDetail() {
		this.pageHelper.cancelRenovatieInfrastructuurDetail();
	}

	// --------------------------RENOVATIE--------------------------------------------------

	handleOnChangeAdres(event, data) {
		const project = this.state.project;

		if (project.breedtegraad != "" || project.lengtegraad != "")
			project.breedtegraad = "";
		project.lengtegraad = "";

		this.setState({
			project: project,
			hasUnsavedChanges: true
		});

		return this.handleOnChange(event, data);
	}

	handleOnGetGeoCoordinates(event) {
		let project = this.state.project;

		let adres = {
			gemeenteId: project.gemeente,
			postcodeId: project.postcode,
			straatHuisnummer: project.straatHuisnummer
		};

		this.props.getGeoCoordinates(adres).then(result => {
			const lengtegraad = result.lengtegraad;
			const breedtegraad = result.breedtegraad;
			const gemeente = adres.gemeenteId;
			const straat = adres.straatHuisnummer;
			const postcode = adres.postcodeId;
			if (lengtegraad && breedtegraad) {
				project.lengtegraad = lengtegraad;
				project.breedtegraad = breedtegraad;
				this.setState({
					project: project,
					hasUnsavedChanges: true,
					center: Object.assign({}, { lat: parseFloat(breedtegraad), lng: parseFloat(lengtegraad) })
				});

				this.props.getInfrastructurenInDeBuurt(lengtegraad, breedtegraad, gemeente, straat, postcode, this.state.inEditMode, project);
			}
		});
	}

	handleOnOpenModal() {
		this.setState({ modalIsOpen: true });
	}

	handleOnCloseModal() {
		this.setState({ modalIsOpen: false });
	}

	handleOnOpenDeleteModal() {
		this.setState({ deleteInfraModalIsOpen: true });
	}

	handleOnCloseDeleteModal() {
		this.setState({ deleteInfraModalIsOpen: false });
	}

	handleOnSave(event) {
		event.preventDefault();

		if (this.state.infrastructuurDeleted && !this.state.modalIsOpen)
			this.handleOnOpenModal();
		else if (this.state.infraStatusGewijzigd && !this.state.deleteInfraModalIsOpen) {
			this.handleOnOpenDeleteModal();
		}
		else {
			if (this.state.modalIsOpen) {
				this.handleOnCloseModal();
			}

			if (this.state.deleteInfraModalIsOpen) {
				this.handleOnCloseDeleteModal();
			}

			let project = mergeDeep({}, this.state.project);
			if (project.verdwijnenErInfrastructuren && project.sportinfrastructurenInDeBuurt.filter(x => x.soortWerken !== domainConstants.INFRASTRUCTUUR_TYPE.NIEUWBOUW).length <= 0) {
				project.verdwijnenErInfrastructurenNietInSpakki = true;
			}

			this.props.saveProject(project)
				.then((notification) => {
					let isSaved = showToastr(notification);
					if (this.state.infraStatusGewijzigd) {
						window.parent.scrollTo(0, 450);
					}
					if (isSaved)
						this.setState({
							infrastructuurDeleted: false,
							hasUnsavedChanges: false,
							project
						});
				});
		}
	}

	componentWillUnmount() {
		this.prefillHelper.unbind();

		if (!this.state.shouldKeepProject) {
			this.props.unloadProject();
		}

	}

	// ----------------------------------------------------------------------------
	isReadyToRender() {
		// entity not loaded? not ready yet...
		if (!this.state.project) {
			return false;
		}
		//Required reference data not loaded? Not ready
		if (this.props.postcodes.length <= 0 ||
			this.props.gemeenten.length <= 0 ||
			this.props.soortenInfrastructuur.length <= 0 ||
			this.props.soortenInfrastructuurAll.length <= 0) {
			return false;
		}

		return true;
	}

	handleOnReplacePoint() {
		this.setState({
			inEditMode: true
		}, () => { this.props.loadLayout(this.state.project.naam, this.state.project.tabTitel, this.state.dossierId, this.state.project.initialisatieOK, this.state.project.typeDossier, this.state.infrastructuurId, (this.state.project.redenVanStatus != "121450000" && this.props.project.redenVanStatus !== 121450000), this.state.inEditMode); });
	}

	handleOnDragEnd(e) {
		const movedMarker = mergeDeep({}, this.state.newCoordinates);

		movedMarker.lat = e.target.getLatLng().lat;
		movedMarker.lng = e.target.getLatLng().lng;

		this.setState({
			newCoordinates: movedMarker
		});
	}

	handleOnSaveNewPoint(event) {
		let newProject = Object.assign({}, this.state.project, { breedtegraad: parseFloat(this.state.newCoordinates.lat), lengtegraad: parseFloat(this.state.newCoordinates.lng) });

		let adres = {
			gemeenteId: newProject.gemeente,
			postcodeId: newProject.postcode,
			straatHuisnummer: newProject.straatHuisnummer
		};

		this.props.saveProject(newProject, this.state.documenten).then(_ => {
			this.setState({
				inEditMode: false,
				mapKey: GenerateGuid()
			}, () => {
				this.props.loadLayout(this.state.project.naam, this.state.project.tabTitel, this.props.dossierId, this.state.project.initialisatieOK, this.state.project.typeDossier, this.state.infrastructuurId, (this.state.project.redenVanStatus != "121450000" && this.props.project.redenVanStatus !== 121450000), this.state.inEditMode);

				this.props.getGeoCoordinates(adres).then(result => {
					const lengtegraad = newProject.lengtegraad;
					const breedtegraad = newProject.breedtegraad;
					const gemeente = adres.gemeenteId;
					const straat = adres.straatHuisnummer;
					const postcode = adres.postcodeId;
					if (lengtegraad && breedtegraad) {
						this.props.getInfrastructurenInDeBuurt(lengtegraad, breedtegraad, gemeente, straat, postcode, this.state.inEditMode, newProject);
					}
				});
			});
		});
	}

	handleOnCancelReplace() {
		let originalCoordinates = Object.assign({}, { lat: parseFloat(this.state.project.breedtegraad), lng: parseFloat(this.state.project.lengtegraad) });
		this.setState({
			inEditMode: false,
			center: originalCoordinates,
			newCoordinates: originalCoordinates
		}, () => { this.props.loadLayout(this.state.project.naam, this.state.project.tabTitel, this.props.dossierId, this.state.project.initialisatieOK, this.state.project.typeDossier, this.state.infrastructuurId, (this.state.project.redenVanStatus != "121450000" && this.props.project.redenVanStatus !== 121450000), this.state.inEditMode); });
	}

	handleOnClickTooltop(value, i) {
		if (i != -1) {
			const project = this.state.project;

			project.sportinfrastructurenOpKaart[i] = Object.assign(project.sportinfrastructurenOpKaart[i], { tooltip: value });
			this.setState({ project: project });
		} else {
			this.setState({ tooltip: value });
		}
	}

	handleOnChangeSoortDossier(event) {
		const project = this.state.project;
		const field = event.target.name;
		const value = event.target.value;
		let nieuwbouwModalOpen = value === domainConstants.DOSSIER_SOORT_NIEUWBOUW.toString() || value === domainConstants.DOSSIER_SOORT_NIEUWBOUWRENOVATIE.toString();

		project[field] = value;

		return this.setState({
			project: project,
			hasUnsavedChanges: true,
			nieuwbouwModalIsOpen: nieuwbouwModalOpen
		});
	}

	render() {
		if (!this.isReadyToRender())
			return null;

		const {
			maxMapFeaturesToLoad,
			osmBaseLayerUrl
		} = this.props;

		return (
			<div>
				{this.state.project.version > 0
					? <ConfirmModal
						hookToTop={false}
						isOpen={this.state.modalIsOpen}
						title="Opgelet: sportinfrastructuur verwijderd!"
						mainText="Bij het verwijderen van een infrastructuur worden alle gerelateerde gegevens ook verwijderd. Wil je verder gaan?"
						confirmAction={this.handleOnSave}
						cancelAction={this.handleOnCloseModal}
						confirmText="Ga door"
						cancelText="Terug" />
					: ""}
				<ConfirmModal
					hookToTop={false}
					isOpen={this.state.addRenovatieToProjectModalIsOpen}
					mainText="Om de renovatie van een infrastructuur te kunnen toevoegen aan je dossier moet je het volgende formulier verder invullen."
					confirmAction={this.handleOnGoToRenovatieInfrastructuurDetail}
					confirmText="Ga verder"
					cancelText="Terug"
					cancelAction={this.handleOnCancelRenovatieInfrastructuurDetail} />
				<ConfirmModal
					hookToTop={false}
					isOpen={this.state.addNieuwbouwInfraModalIsOpen}
					mainText="Hier mag je enkel een nieuwbouw infrastructuur toevoegen waarvoor je subsidies aanvraagt."
					confirmAction={this.handleOnGoToAddNieuwbouwInfrastructuur}
					confirmText="Ga verder"
					cancelAction={this.handleOnCancelAddNieuwbouwInfrastructuur}
					cancelText="Terug" />
				<ConfirmModal
					hookToTop={false}
					isOpen={this.state.deleteNieuwbouwInfraModalIsOpen}
					mainText="Wil je deze toegevoegde sportinfrastructuur terug verwijderen?"
					confirmAction={this.handleOnGoToDeleteNieuwbouwInfrastructuur}
					confirmText="Ga verder"
					cancelAction={this.handleOnCancelDeleteNieuwbouwInfrastructuur}
					cancelText="Terug" />
				<ConfirmModal
					hookToTop={false}
					isOpen={this.state.addRenovatieInfraModalIsOpen}
					mainText="Hier mag je enkel een bestaande sportinfrastructuur toevoegen die gerenoveerd wordt in dit project en die niet in onze databank staat."
					confirmAction={this.handleOnGoToAddRenovatieInfrastructuur}
					confirmText="Ga verder"
					cancelAction={this.handleOnCancelAddRenovatieInfrastructuur}
					cancelText="Terug" />
				<ConfirmModal
					hookToTop={false}
					isOpen={this.state.deleteInfraModalIsOpen}
					mainText="Opgelet: Je hebt één of meerdere sportinfrastructuren van je subsidieaanvraag gewijzigd naar Nee of Reconversie!
					De sportinfrastructuren die je op Reconversie hebt gezet zullen overal verwijderd worden als infrastructuur op wandelafstand.
					Voor alle sportinfrastructuren die je van Ja naar Nee of Reconversie gezet hebt worden alle gerelateerde gegevens ivm minimale eisen en bovenlokaliteit verwijderd.
					Wil je verder gaan?"
					confirmAction={this.handleOnSave}
					confirmText="Ga verder"
					cancelAction={this.handleOnCloseDeleteModal}
					cancelText="Terug" />
				<ConfirmModal
					hookToTop={false}
					isOpen={this.state.nieuwbouwModalIsOpen}
					mainText="Bevat uw project werkzaamheden aan de randaccommodatie van een bestaande openlucht sportinfrastructuur (vb. bouwen van kleedkamers,
						plaatsen van omheiningen of verlichtingspalen …) dan is dit geen nieuwbouw maar moeten deze werkzaamheden opgegeven worden als
						renovatiewerkzaamheden aan de bestaande openlucht sportinfrastructuur."
					confirmAction={this.handleOnCloseNieuwbouwModal}
					confirmText="OK"
					small />
				<ProjectForm
					project={this.state.project}
					gemeenten={this.props.gemeenten}
					postcodes={this.props.postcodes}
					soortenInfrastructuur={this.props.soortenInfrastructuur}
					soortenInfrastructuurAll={this.props.soortenInfrastructuurAll}
					disabled={this.props.disabled}
					errors={this.props.errors}
					validationMessageType={this.props.validationMessageType}
					onChange={this.handleOnChange}
					onChangeAdres={this.handleOnChangeAdres}
					onChangeSoortDossier={this.handleOnChangeSoortDossier}
					onEditNieuwbouw={this.handleOnEditNieuwbouw}
					onDeleteNieuwbouw={this.handleOnDeleteNieuwbouw}
					onEditRenovatie={this.handleOnEditRenovatie}
					onAddNieuwbouwInfrastructuur={this.handleOnAddNieuwbouwInfrastructuur}
					onAddRenovatieInfrastructuur={this.handleOnAddRenovatieInfrastructuur}
					onChangeRenovatieTable={this.handleOnChangeRenovatieTable}
					onChangeVerdwijnendeInfrasTable={this.handleOnChangeVerdwijnendeInfrasTable}
					onGetGeoCoordinates={this.handleOnGetGeoCoordinates}
					onSave={this.handleOnSave}
					color={types.COLOR_PINK}
					pdf={this.state.pdf}
					isPollingDocument={this.state.timer ? true : false}
					generatePdf={this.handleOnGeneratePdf}
					hasUnsavedChanges={this.state.hasUnsavedChanges}
					mapKey={this.state.mapKey}
					onReplacePoint={this.handleOnReplacePoint}
					saveNewPoint={this.handleOnSaveNewPoint}
					cancelReplace={this.handleOnCancelReplace}
					inEditMode={this.state.inEditMode}
					newCoords={this.state.newCoordinates}
					onClickTooltip={this.handleOnClickTooltop}
					maxMapFeaturesToLoad={maxMapFeaturesToLoad}
					osmBaseLayerUrl={osmBaseLayerUrl}
					onMarkerDragEnd={this.handleOnDragEnd}
				/>
			</div>
		);
	}
}

// ----------------------------------------------------------------------------
ProjectPage.propTypes = {
	project: PropTypes.object.isRequired,
	loadLayout: PropTypes.func.isRequired,
	loadProject: PropTypes.func.isRequired,
	params: PropTypes.object.isRequired,
	saveProject: PropTypes.func.isRequired,
	postcodes: PropTypes.array.isRequired,
	gemeenten: PropTypes.array.isRequired,
	soortenInfrastructuur: PropTypes.array.isRequired,
	soortenInfrastructuurAll: PropTypes.array.isRequired,
	errors: PropTypes.object,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
	const dossierId = ownProps.params.dossierId;
	const project = state.project;
	const disabled = state.ajaxCounter > 0 || state.settings.lockAllDossiers || ((project.item) && project.item.redenVanStatus == 121450000);

	const infrastructuurId = project && project.item && project.item.infrastructuren && project.item.infrastructuren.length > 0 ? project.item.infrastructuren[project.item.infrastructuren.length - 1].id : null;
	const soortenInfrastructuur = !(project && (project.item.andereInfrastructurenBeschikbaar === true || project.item.andereInfrastructurenBeschikbaar === "true")) ? state.referentie.soortenInfrastructuur.filter((x, i) => i > 0) : state.referentie.soortenInfrastructuur;

	return {
		dossierId: dossierId,
		project: project.item,
		isLoaded: project.isLoaded,
		postcodes: convertToLabelValuePair(state.referentie.postcodes),
		gemeenten: convertToLabelValuePair(state.referentie.gemeenten),
		soortenInfrastructuur: soortenInfrastructuur,
		soortenInfrastructuurAll: state.referentie.soortenInfrastructuurAll,
		errors: project.errors,
		validationMessageType: project.hasValidationErrors ? types.ValidationMessageTypes.ERROR : types.ValidationMessageTypes.WARNING,
		disabled: disabled,
		infrastructuurId: infrastructuurId,
		isSaved: state.project.isSaved,
		pageHeaderTitle: state.layout.pageHeaderTitle,
		pageHeaderSubtitle: state.layout.pageHeaderSubtitle,
		maxMapFeaturesToLoad: state.settings.maxMapFeaturesToLoad,
		osmBaseLayerUrl: state.settings.osmBaseLayerUrl
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadProjectPageLayout, dispatch),
		loadProject: bindActionCreators(projectActions.loadProject, dispatch),
		unloadProject: bindActionCreators(projectActions.unloadProject, dispatch),
		projectLoaded: bindActionCreators(projectActions.projectLoaded, dispatch),
		saveProject: bindActionCreators(projectActions.saveProject, dispatch),
		getEmptyInfrastructuur: bindActionCreators(projectActions.getEmptyInfrastructuur, dispatch),
		getGeoCoordinates: bindActionCreators(projectActions.getGeoCoordinates, dispatch),
		getInfrastructurenInDeBuurt: bindActionCreators(projectActions.getInfrastructurenInDeBuurt, dispatch),
		projectSaved: bindActionCreators(projectActions.projectSaved, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(ProjectPage));
